import ProfileImageComponent from './ProfileImageComponent';

export default ProfileImageComponent;
